export default __webpack_public_path__ + "static/media/Mobile App Development 1.77871780.png";